export const MENU_WIDTH = 280 as const
export const MENU_WIDTH_COLLAPSED = 50 as const
export const CONTENT_MARGIN = 290 as const
export const CONTENT_MARGIN_COLLAPSED = 60 as const

export const NAVIGATION_HIDDEN_CLASS_NAME = 'side-navigation-hidden' as const
export const NAVIGATION_CLASS_NAME = 'side-navigation' as const
export const ITEM_CLASS_NAME = 'side-navigation-item' as const
export const TOGGLE_BUTTON_CLASS_NAME = 'side-navigation-toggle' as const
